import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import { DestroyService } from '@app/core/services/destroy.service'
import { DialogService } from '@app/shared/dialogs/dialog.service'
import { TranslateService } from '@ngx-translate/core'
import { filter, takeUntil } from 'rxjs/operators'

import { DocumentRecord } from '../documents/document.model'
import { RecordEditDialogComponent } from '../record-edit-dialog/record-edit-dialog.component'

@Component({
  selector: 'lin-document-records-list',
  templateUrl: './document-records-list.component.html',
  styleUrls: ['./document-records-list.component.scss'],
  providers: [DestroyService],
  standalone: false,
})
export class DocumentRecordsListComponent implements OnChanges, OnInit {
  @Input() records: DocumentRecord[]
  @Input() isEditMode: boolean
  @Output() editRecord = new EventEmitter<{ record: DocumentRecord; index: number }>()

  @ViewChild(MatPaginator, { static: true }) public paginator: MatPaginator
  @ViewChild(MatSort, { static: true }) public sort: MatSort

  form: FormGroup
  dataSource: MatTableDataSource<DocumentRecord>

  columns = ['issueDate', 'expDate', 'user', 'cost', 'filesAttached', 'notes']
  columnsMandatory = []

  constructor(
    private dialog: DialogService,
    private destroyService: DestroyService,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    if (this.isEditMode) {
      this.columns.push('edit')
      this.columnsMandatory.push('edit')
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.records) {
      this.initDataSource()
    }
  }

  initDataSource() {
    const dataSource = (this.dataSource = new MatTableDataSource<DocumentRecord>(this.records))
    dataSource.paginator = this.paginator
    dataSource.sort = this.sort
  }

  handleEditRecord(record: DocumentRecord, index: number) {
    this.dialog
      .open(RecordEditDialogComponent, <string>this.translateService.instant('CLIENT.VEHICLES.DOCUMENTS.EDIT_RECORD'), record)
      .afterClosed()
      .pipe(filter(Boolean), takeUntil(this.destroyService))
      .subscribe((updatedRecord: DocumentRecord) =>
        this.editRecord.emit({
          record: { ...record, ...updatedRecord },
          index,
        }),
      )
  }
}
